<template>
  <router-link :to="href" v-bind:class="['btn', sizeClass, btnClass]" :target="target">
    <i v-bind:class="['fa', iconClass]"></i> <slot />
  </router-link>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    type: String,
    href: String,
    icon: String,
    sizeClass: {
      type: String,
      default: 'btn-xs'
    },
    colourClass: {
      type: String,
      default: 'btn-primary'
    },
    newTab: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonMap: {
        new: { icon: 'fa-plus', class: 'btn-primary' },
        delete: { icon: 'fa-times', class: 'btn-danger' },
        archive: { icon: 'fa-archive', class: 'btn-warning' },
        edit: { icon: 'fa-pencil', class: 'btn-white' },
        newLog: { icon: 'fa-comment', class: 'btn-primary' },
        link: { icon: 'fa-external-link', class: 'btn-white' }
      }
    };
  },
  computed: {
    iconClass() {
      return this.buttonMap[this.type] ? this.buttonMap[this.type].icon : this.icon;
    },
    btnClass() {
      return this.buttonMap[this.type] ? this.buttonMap[this.type].class : this.colourClass;
    },
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
};
</script>
